import './../../assets/css/App.css';
import './../../assets/css/layout.css';
import './../../assets/css/global/components.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/ui/widgets/datepicker';
import React, { Component } from 'react';
import PageTitle from './../../component/pageTitle'
import TabPanelView from './tabPanelView';

class Dashboard extends Component {

    render() {
        return (
            <div className="page-content-wrapper">
                <PageTitle pageTitle = {"Canned Reports Page"} ></PageTitle>
                <div className="page-content tabbable-custom column-xs-12">
                    <TabPanelView></TabPanelView>
                </div>
            </div>
        );
    }
}

export default Dashboard;
